import * as cpfCpnj from 'cpf-cnpj-validator'

export const validateCnpj = (cnpj, setCnpjInvalid) => {
  if (cnpj !== '' && cnpj !== '__.___.___/____-__') {
    const valid = cpfCpnj.cnpj.isValid(cnpj)
    !valid ? setCnpjInvalid(true) : setCnpjInvalid(false)
  }
}
